import { IPagination } from 'modules/web-molecules'

export default function usePaginationBoundaries(pagination: IPagination) {
  const pageStarting = Math.min(pagination.pageIndex * pagination.pageSize + 1, pagination.total)
  const pageEnding = Math.min(pageStarting - 1 + pagination.pageSize, pagination.total)

  return { pageStarting, pageEnding }
}
